import styled from 'styled-components';

export const DividerWrapper = styled.div`
  height: 60px;
`;

export const StarWrapper = styled.span`
  color: ${({ theme }) => theme.color.support.orange.strong};
  margin-left: ${({ theme }) => theme.spacing.km1};
`;
